import { makeStyles, Button, Box } from "@material-ui/core";
import React from "react";
import Modal from "react-awesome-modal";
import { DropzoneArea } from "material-ui-dropzone";
import { backend } from "../../../../api";
import { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";

const useStyles = makeStyles((theme) => ({
  modalContainer: {
    width: "90%",
    margin: "20px auto",
  },
  modalHeading: {
    fontSize: 24,
    fontWeight: 550,
    marginBottom: 0,
  },
  modalLine: {
    margin: "20px auto",
    width: "100%",
    color: theme.palette.secondary.dark,
  },
  submitBtn: {
    color: theme.palette.secondary.light,
    backgroundColor: theme.palette.primary.main,
    width: 100,
    borderRadius: 2,
    padding: "8px 0",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: "white",
    },
  },
  cancelBtn: {
    backgroundColor: theme.palette.secondary.dark,
    width: 100,
    borderRadius: 2,
    padding: "8px 0",
    color: theme.palette.secondary.light,
  },
}));

function ChangeCoverModal(props) {
  const { visible, closeModal, bookId } = props;
  const [bookCover, setBookCover] = useState("");
  let formData;
  const classes = useStyles();
  const uploadFileToS3 = (file) => {
    formData = new FormData();
    formData.append("files", file);
    backend
      .post("/file/fileUpload", formData)
      .then((res) => {
        if (res.status === 200) {
          setBookCover(res.data.locationArray[0].fileLocation);
        }
      })
      .catch((err) => {
        let message = err.response ? err.response.data.message : err.message;
        // toast.error(message);
      });
  };

  const handleFormSubmit = () => {
    const newCover = {
      book_cover: bookCover,
    };
    backend
      .put(`/book/${bookId}`, newCover)
      .then((res) => {
        closeModal();
        if (res.data.message === "Book Updated Successfully") {
          Swal.fire({
            title: "Congratulations",
            icon: "success",
            confirmButtonText: "OK",
            text: "Book Cover Updated Successfully",
          }).then((result) => {
            closeModal();
          });
        }
      })
      .catch((err) => {
        if (err.response) {
          toast.error(err.response.data.message);
        } else {
          toast.error(err.message);
        }
      });
  };
  return (
    <Modal
      visible={visible}
      width="500"
      effect="fadeInUp"
      onClickAway={closeModal}
    >
      <div className={classes.modalContainer}>
        <h3 className={classes.modalHeading}>Add Book</h3>
        <hr className={classes.modalLine} />

        <DropzoneArea
          onChange={(files) => uploadFileToS3(files[0])}
          acceptedFiles={["image/*"]}
          filesLimit={1}
          dropzoneText="Upload Image for Book Cover"
          style={{ maxHeight: 100 }}
        />
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mt={4}
        >
          <Button className={classes.cancelBtn} onClick={closeModal}>
            Cancel
          </Button>
          <Button
            className={classes.submitBtn}
            onClick={handleFormSubmit}
            disabled={!bookCover}
          >
            Update
          </Button>
        </Box>
      </div>
    </Modal>
  );
}

export default ChangeCoverModal;
